// extracted by mini-css-extract-plugin
export default {"permission-container":"permission-container__qzrc3","indicator-badge":"indicator-badge__XWTK3","granted":"granted__SQDAv"};